import { parseQuery } from '@calendly/http-tools'

export const buildTracking = () => {
  const query = parseQuery(window.location.search)
  const result = {
    utm_campaign: query.utm_campaign || query.pid,
    utm_source: query.utm_source,
    utm_medium: query.utm_medium,
    utm_content: query.utm_content,
    utm_term: query.utm_term,
    salesforce_uuid: query.salesforce_uuid || query.sfid
  }

  return Object.fromEntries(
    Object.entries(result).filter(([_key, value]) => value !== undefined)
  )
}
